import React from 'react';

import { Column, Text, Space, Notification } from 'farmhub-ui-core';

import { useAppDispatch } from 'app';
import { Empty, TaskItemSkeleton, dataEmpty } from 'components';
import { filterOrderTasks, updateOrderTask } from 'slice';
import { getDummyArray } from 'utils';

import TaskItem from './components/TaskItem';

type OrderTaskTabPaneProps = {
  orderID: string;
  isOrderLoading: boolean;
  query?: any;
  type?: number;
};

const OrderTaskTabPane = ({
  orderID,
  isOrderLoading,
  query,
  type,
}: OrderTaskTabPaneProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isAssigningID, setIsAssigningID] = React.useState('');
  const [tasks, setTasks] = React.useState<any[]>([]);

  const taskType = React.useMemo(() => {
    if (query?.type != undefined) {
      return query?.type;
    }
    return type;
  }, [query?.type, type]);

  const handleAssigneeTask = async (
    orderTaskID: string,
    assigneeID: string
  ) => {
    try {
      setIsAssigningID(orderTaskID);
      const result: any = await dispatch(
        updateOrderTask({
          id: orderTaskID,
          body: {
            assigneeID,
          },
        })
      ).unwrap();
      const { data } = result;

      setTasks(prevState =>
        prevState.map((item: any) => (item.id == orderTaskID ? data : item))
      );
    } catch (error: any) {
      Notification('error', 'Phân công đơn hàng thất bại', error);
    } finally {
      setIsAssigningID('');
    }
  };

  React.useEffect(() => {
    const findOrderInfo = async () => {
      try {
        setIsLoading(true);
        const result: any = await dispatch(
          filterOrderTasks({
            orderID: orderID ?? '',
            type: taskType ?? '',
          })
        ).unwrap();

        const { data } = result;
        setTasks(data);
      } catch (error) {
        console.log(
          'An error occurred while getting order info/ order logs',
          error
        );
      } finally {
        setIsLoading(false);
      }
    };

    if (orderID || query) {
      findOrderInfo();
    }
  }, [dispatch, orderID, query]);

  return (
    <Column styles={{ padding: '12px 18px' }}>
      <Text color="primary" weight="bold">
        Công việc xử lý ({tasks.length}):
      </Text>
      <Space height={6} />
      {isOrderLoading || isLoading ? (
        getDummyArray(5).map((item: any) => <TaskItemSkeleton />)
      ) : tasks.length > 0 ? (
        tasks.map((item: any) => (
          <TaskItem
            data={item}
            isAssigning={isAssigningID == item.id}
            onAssignee={handleAssigneeTask}
          />
        ))
      ) : (
        <Empty
          description="Hiện tại không có phân công"
          img={dataEmpty.MISSION}
        />
      )}
    </Column>
  );
};

export default OrderTaskTabPane;
